/**
 * All 27 UF finance hosts are on the watchlist (official-v12). This is a
 * source watchlist, not a published rate table.
 */
export const WATCHED_SEFAZ_UFS = [
  "AC",
  "AL",
  "AM",
  "AP",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MG",
  "MS",
  "MT",
  "PA",
  "PB",
  "PE",
  "PI",
  "PR",
  "RJ",
  "RN",
  "RO",
  "RR",
  "RS",
  "SC",
  "SE",
  "SP",
  "TO",
] as const;

export type WatchedSefazUf = (typeof WATCHED_SEFAZ_UFS)[number];

const WATCHED_SEFAZ = new Set<string>(WATCHED_SEFAZ_UFS);

export const WATCHED_SEFAZ_COUNT = WATCHED_SEFAZ_UFS.length;
export const BRAZIL_UF_COUNT = 27;

export function isWatchedSefaz(uf: string): boolean {
  return WATCHED_SEFAZ.has(uf.toUpperCase());
}
